import React, { Fragment, useState, useEffect } from 'react';
import { Breadcrumbs } from '../../../../AbstractElements';
import { ProductListDesc, pinagareFilesUpload,pinagareAPIURL } from '../../../../Constant';
import ProductTableData from '../../Project/Project/ProductTableData';
import { Card, CardBody, Col, Container, Row, NavLink, Nav, NavItem, Label, Modal, ModalHeader, ModalBody, Input, FormGroup, Form } from 'reactstrap';
import HeaderCard from '../../../Common/Component/HeaderCard';
import { Btn, H6, H5, Image, P, H4 } from '../../../../AbstractElements';
import { Link } from 'react-router-dom';
import DataTable from 'react-data-table-component';
import { ToastContainer, toast } from "react-toastify";
import { Target, Info, CheckCircle, PlusCircle } from 'react-feather';
import CommonModal from '../../../UiKits/Modals/common/modal'; 
import { useForm } from 'react-hook-form';
import { trackPromise } from 'react-promise-tracker';
import SmallWidgets from '../../../Common/CommonWidgets/SmallWidgets';
import BoardMeetingPanel from '../../../Dashboard/Ecommerce/BoardMeetingPanel';
import SingleFileUploader from '../../../FileUpload/SingleFileUploader'; 
import SingleUpload from '../../../FileUpload/SingleUpload'; 
import PromiseSpinner from '../../../../CommonElements/Spinner/PromiseSpinner';


const ProductListContain = () => {

    const style = {
        width: 40,
        height: 40,
      };
    const style2 = { width: 60, fontSize: 14, padding: 4 };

       
    const [taskData, setTaskData] = useState([]);
    let newList = [...taskData];
    let qCandidatesList = [...taskData];
    let apprCandidatesList = [...taskData];
    let rejCandidatesList = [...taskData];
    let withdCandidatesList = [...taskData];
    const [isPrepopulatedDataIn, setIsPrepopulatedDataIn] = useState(false);
    const [pinagareSupervisorTasks, setPinagareSupervisorTasks] = useState([]);
    const [supTasksItems, setSupTasksItems] = useState([]);
    const [supTasksTotalRows, setSupTasksTotalRows] = useState(0);
    const [supTasksPerPage, setSupTasksPerPage] = useState(10);

    const [pinagareQualifyingCandidates, setPinagareQualifyingCandidates] = useState([]);
    const [qualifyingCandItems, setQualifyingCandItems] = useState([]);
    const [qualifyingCandTotalRows, setQualifyingCandTotalRows] = useState(0);
    const [qualifyingCandPerPage, setQualifyingCandPerPage] = useState(10);

    const [pinagareApprovedCandidates, setPinagareApprovedCandidates] = useState([]);
    const [approvedCandItems, setApprovedCandItems] = useState([]);
    const [approvedCandTotalRows, setApprovedCandTotalRows] = useState(0);
    const [approvedCandPerPage, setApprovedCandPerPage] = useState(10);

    const [pinagareRejectedCandidates, setPinagareRejectedCandidates] = useState([]);
    const [rejectedCandItems, setRejectedCandItems] = useState([]);
    const [rejectedCandTotalRows, setRejectedCandTotalRows] = useState(0);
    const [rejectedCandPerPage, setRejectedCandPerPage] = useState(10);

    const [pinagareWithdrawnCandidates, setPinagareWithdrawnCandidates] = useState([]);
    const [withdrawnCandItems, setWithdrawnCandItems] = useState([]);
    const [withdrawnCandTotalRows, setWithdrawnCandTotalRows] = useState(0);
    const [withdrawnCandPerPage, setWithdrawnCandPerPage] = useState(10);

    const [isCommitteeMember, setIsCommitteeMember] = useState(false);
    const [isSecretariatOfficer, setIsSecretariatOfficer] = useState(false);
    const [isBoardChairperson, setIsBoardChairperson] = useState(false);
    const [isBoardSecretary, setIsBoardSecretary] = useState(false);
    const initBudgetNguidelines = { qualifying_candidates:0,allocated_budget: null, evaluation_guidelines: null};           
    const [budgetNguidelines, setBudgetNguidelines] = useState(initBudgetNguidelines);
    const [modal, setModal] = useState(false);
    const toggle = () => setModal(!modal);
    const [modal2, setModal2] = useState(false);
    const toggle2 = () => setModal2(!modal2);
    const [modal3, setModal3] = useState(false);
    const toggle3 = () => {//alert('ola '+modal3);
      setModal3(!modal3);
    }
    const [withdrawalSearchResultsIn, setWithdrawalSearchResultsIn] = useState(false);
    const [qualifyingMarkModal, setQualifyingMarkModal] = useState(false);
    const qualifyingMarkToggle = () => {
      setQualifyingMarkModal(!qualifyingMarkModal);
    }
    const [viewBoardPackModal, setViewBoardPackModal] = useState(false);
    const [startMeetingModal, setStartMeetingModal] = useState(false);
    const [applicationPeriodModal, setApplicationPeriodModal] = useState(false);

    const viewBoardPackToggle = () => {
      setViewBoardPackModal(!viewBoardPackModal);
    }
    
    const [anyMeetingApologies, setAnyMeetingApologies] = useState(false);
    const [withdrawApplicationModal, setWithdrawApplicationModal] = useState(false);
    const [searchApplicationModal, setSearchApplicationModal] = useState(false);
    const [isSearchApplication, setIsSearchApplication] = useState(false);
    
    const {
      register,
      handleSubmit,
      formState: { errors },
    } = useForm(); // initialise the hook

    const {
      register:register2,
      handleSubmit:handleSubmit2,
      formState: { errors:errors2 },
    } = useForm();

    const {
      register:register3,
      handleSubmit:handleSubmit3,
      formState: { errors:errors3 },
    } = useForm();

    const {
      register:register4,
      handleSubmit:handleSubmit4,
      reset:reset4,
      formState: { errors:errors4 },
    } = useForm();

    const {
      register:register5,
      handleSubmit:handleSubmit5,
      formState: { errors:errors5 },
    } = useForm();

    const {
      register:register6,
      handleSubmit:handleSubmit6,
      reset:reset6,
      formState: { errors:errors6 },
    } = useForm();
    
if(localStorage.getItem("is_onbehalf_application")!=null) localStorage.removeItem("is_onbehalf_application");

const startMeetingToggle = (event) => {//alert('Meeting sarted '+budgetNguidelines.evaluation_meeting_ended);
  event.preventDefault();
   reset4();
   setAnyMeetingApologies(false);
  setStartMeetingModal(!startMeetingModal);
}
const applicationPeriodToggle =()=>{
  setApplicationPeriodModal(!applicationPeriodModal);
}

const withdrawApplicationToggle = (event) => {//alert('withdraw');
   event.preventDefault();
   reset6();
   delete budgetNguidelines.omang_to_withdraw_exists;
   budgetNguidelines.omang_to_withdraw='';
   setBudgetNguidelines(budgetNguidelines);
   setWithdrawalSearchResultsIn(false);
   setIsSearchApplication(false);
   setWithdrawApplicationModal(!withdrawApplicationModal);
   
   
}

const searchApplicationToggle = (event) => {//alert('search ');
  event.preventDefault();
  reset6();
  delete budgetNguidelines.omang_to_withdraw_exists;
  budgetNguidelines.omang_to_withdraw='';
  setBudgetNguidelines(budgetNguidelines);
  setWithdrawalSearchResultsIn(false);
  if(searchApplicationModal)setIsSearchApplication(false);
  else setIsSearchApplication(true);
  setSearchApplicationModal(!searchApplicationModal);

}

const onSubmit = (data) => {//alert('kk');

  if (data !== '') {

    let this_eng='';
    let this_body=null

    if(data.qualifying_mark!=undefined&&data.qualifying_mark!=null){

      this_body=JSON.stringify({
        
        omang:localStorage.getItem('username'),
        eng:'update_pinagare_qualifying_mark',  
        qualifying_mark:data.qualifying_mark,       
        
      });
      this_eng='qualifying_mark';
    }
    else{
      
      this_body=JSON.stringify({
        
      omang:localStorage.getItem('username'),
      eng:'update_pinagare_evaluation_guidelines', 
      budget:data.budget, 
      evaluation_guidelines:data.evaluation_guidelines,       
      
    });

    this_eng='evaluation_guidelines';
    }

    trackPromise(
      pinagareSendRequest(pinagareAPIURL,this_body,this_eng)
     );

  } else {
    errors.showMessages();
  }
};

const onSubmit2 = (data) => {

  if (data !== '') {
      
    const body=JSON.stringify({
        
      omang:localStorage.getItem('username'),
      eng:'send_notification_emails_to_pinagare_applicants', 
      target_email_group:data.target_email_group,       
      
    });

    trackPromise(
      pinagareSendRequest(pinagareAPIURL,body,'send_conclusion_notifications')
     );

  } else {
    errors2.showMessages();
  }
};

const onSubmit3 = (data) => {

  if (data !== '') {
      
   
      let this_body=JSON.stringify({
        
        omang:localStorage.getItem('username'),
        eng:'update_pinagare_qualifying_mark',  
        qualifying_mark:data.qualifying_mark,       
        
      });
      let this_eng='qualifying_mark';
   


    trackPromise(
      pinagareSendRequest(pinagareAPIURL,this_body,this_eng)
     );

  } else {
    errors3.showMessages();
  }
};

const onSubmit4 = (data) => {//alert('ddd');

  if (data !== '') {

    //if(data.any_meeting_apologies=="yes"&&(data.apology_omang1==undefined||data.apology_omang1=="")){
      //setAnyMeetingApologies(data.any_meeting_apologies);
      //errors4.showMessages();
    //}
    //else{
      //alert('sent...');

    const body=JSON.stringify({
        
      omang:localStorage.getItem('username'),
      eng:'start_end_pinagare_evaluation_meeting', 
      any_meeting_apologies:data.any_meeting_apologies,
      apology_omang1:data.apology_omang1,
      apology_omang2:data.apology_omang2,
      evaluation_meeting_ended:budgetNguidelines.evaluation_meeting_ended,       
      
    });

    trackPromise(
      pinagareSendRequest(pinagareAPIURL,body,'start_end_pinagare_evaluation_meeting')
     );

    //}

  } else {//alert(JSON.stringify(errors4));
    errors4.showMessages();
  }
};

const onSubmit5 = (data) => {

  //if (data !== '') {
      
   
      let this_body=JSON.stringify({
        
        omang:localStorage.getItem('username'),
        eng:'start_end_pinagare_applications_period',  
        applications_period_ended:budgetNguidelines.applications_period_ended,       
        
      });

      let this_eng='start_end_pinagare_applications_period';
   

    trackPromise(
      pinagareSendRequest(pinagareAPIURL,this_body,this_eng)
     );

  //} else {
   // errors5.showMessages();
 // }
};

const onSubmit6 = (data) => {//alert("withdraw");


  if (data !== '') {
      
    const body=JSON.stringify({
        
      omang:localStorage.getItem('username'),
      eng:'withdraw_pinagare_application', 
      omang_to_withdraw:data.omang_to_withdraw,
      application_id:data.application_id,       
      
    });

    trackPromise(
      pinagareSendRequest(pinagareAPIURL,body,'withdraw_pinagare_application')
     );

  } else {
    errors6.showMessages();
  }
};

const onSubmit6b = (data) => {//alert("search");


  if (data !== '') {
      
    const body=JSON.stringify({
        
      omang:localStorage.getItem('username'),
      eng:'search_pinagare_application_to_withdraw', 
      omang_to_withdraw:data.omang_to_withdraw,       
      
    });

    trackPromise(
      pinagareSendRequest(pinagareAPIURL,body,'search_pinagare_application_to_withdraw')
     );

  } else {
    errors6.showMessages();
  }
};


const handleInputClickP = (event) => {
 
    const { name, value } = event.target;  
     

    if(event.target.name=="any_meeting_apologies"){//alert(event.target.value);

      
       if(event.target.value=='yes'){
        setAnyMeetingApologies(true);
      }
      else{
        setAnyMeetingApologies(false);
      }
            
    }
    else {
     
   }
}
 
async function pinagareSendRequest(url,body,eng) {
    
  try {
    
    await fetch(url, {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      },
      body: body,
    })
      .then((respose) => {
        if (respose.ok) {
      
          return respose.json()
        }
        throw new Error('error')
      })
      .then((data) => {

      //alert(eng);

        if (data.status!=null&&data.status!=undefined&&data.status) {

          if(eng=='evaluation_guidelines'){
              toast.success("Evaluation Guidelines Updated Successfully!");
              toggle3();
             
            setBudgetNguidelines({ ...budgetNguidelines, ["allocated_budget"]: data.budget,["evaluation_guidelines"]: data.evaluation_guidelines });
           }
           else if(eng=='search_pinagare_application_to_withdraw'){

            toast.success("Search executed successfully! Review the results below, and confirm.");
            setWithdrawalSearchResultsIn(true);
                       
            setBudgetNguidelines({ ...budgetNguidelines, ["withdrawal_applicant_details"]: data.withdrawal_applicant_details,["omang_to_withdraw"]: data.omang_to_withdraw, ["omang_to_withdraw_exists"]: data.omang_to_withdraw_exists });
           
          }
         else if(eng=='qualifying_mark'){

            toast.success("Qualifying mark Updated Successfully!");
            qualifyingMarkToggle();
           
          setBudgetNguidelines({ ...budgetNguidelines, ["qualifying_mark"]: data.qualifying_mark });
         }
         else if(eng=='start_end_pinagare_applications_period'){
          
          if(budgetNguidelines.applications_period_ended)toast.success("Application period STARTED Successfully! Applicants CAN NOW submit applications.");
          else toast.success("Application period ENDED Successfully! Applicants can NO LONGER submit applications.");
          applicationPeriodToggle();
         //alert(data.message);
        setBudgetNguidelines({ ...budgetNguidelines, ["applications_period_ended"]: data.applications_period_ended });
       }
       else if(eng=='withdraw_pinagare_application'){

        toast.success("Application Withdrawn Successfully!");        
        reset6();        
        setWithdrawApplicationModal(!withdrawApplicationModal);
       
      
    }
      else if(eng=='start_end_pinagare_evaluation_meeting'){

          if(budgetNguidelines.evaluation_meeting_ended)toast.success("Meeting Started Successfully!");
          else toast.success("Meeting Ended Successfully!");

          //startMeetingToggle();
          reset4();
          setAnyMeetingApologies(false);
          setStartMeetingModal(!startMeetingModal);
         
        setBudgetNguidelines({ ...budgetNguidelines, ["evaluation_concluded"]: false, ["meeting_start_time"]: data.meeting_start_time, ["meeting_attendees"]: data.meeting_attendees, ["evaluation_meeting_ended"]: data.evaluation_meeting_ended });
       
      }
        else{
              toast.success("Notification Successfully Sent to Candidates!");
              toggle2();
        }
                       
        } else {
          

          if(data.status==false){
            toast.error(data.message);
            
          }
          else{
            if(eng=='evaluation_guidelines'){
               toast.error(" Network Error occurred... Could not update evaluation guidelines... "+data.message);
             }
             else if(eng=='qualifying_mark'){
              toast.error(" Network Error occurred... Could not update qualifying mark... "+data.message);
            }
            else if(eng=='start_end_pinagare_evaluation_meeting'){
              toast.error(" Network Error occurred... Could not start/end meeting... "+data.message);
            }
            else if(eng=='start_end_pinagare_applications_period'){
              toast.error(" Network Error occurred... Could not start/end applications period... "+data.message);
            }
            else if(eng=='withdraw_pinagare_application'){
              toast.error(" Network Error occurred... Could not withdraw application... "+data.message);
            }
            else if(eng=='search_pinagare_application_to_withdraw'){
              toast.error(" Network Error occurred... Could not search the application to be withdrawn... "+data.message);
              setWithdrawalSearchResultsIn(false);
            }
             else{
              toast.error(" Network Error occurred... Could not send notifications to applicants... "+data.message);
             }
          }
         
         
        }
      })
      //.then((error) => {//alert(JSON.stringify(error));
     // })

   
  } catch (error) {
    //console.log(JSON.stringify(error)+" --"); 
    toast.error("Network Error occurred.. Could not send request.."+JSON.stringify(error));
  
  }

}


 const productColumns = [
  
    {
      name: 'Application Details',
      selector: (row) => row.Details,
      sortable: true,
      center: false,
      wrap: true,
      minWidth: '350px',
    },
    {
      name: 'Employee ID',
      selector: (row) => row.amount,
      sortable: true,
      center: true,
      minWidth: '100px',
      maxWidth: '150px',
    },
    {
      name: 'Status',
      selector: (row) => row.stock,
      sortable: true,
      center: true,
      minWidth: '170px',
      maxWidth: '230px',
    },
    {
      name: 'Application Date',
      selector: (row) => row.start_date,
      sortable: true,
      center: true,
      minWidth: '150px',
      maxWidth: '150px',
    },
    {
      name: 'Action',
      selector: (row) => row.action,
      sortable: true,
      center: true,
      minWidth: '100px',
      maxWidth: '130px',
    },
  ];

  const qCandidatesColumns = [
  
    {
      name: 'Application Details',
      selector: (row) => row.Details,
      sortable: true,
      center: false,
      wrap: true,
      minWidth: '350px',
    },
    {
      name: 'Employee ID',
      selector: (row) => row.amount,
      sortable: true,
      center: true,
      minWidth: '100px',
      maxWidth: '150px',
    },
    {
      name: 'Score',
      selector: (row) => row.stock,
      sortable: true,
      center: true,
      minWidth: '170px',
      maxWidth: '230px',
    },
    {
      name: 'Application Date',
      selector: (row) => row.start_date,
      sortable: true,
      center: true,
      minWidth: '150px',
      maxWidth: '150px',
    },
    {
      name: 'Action',
      selector: (row) => row.action,
      sortable: true,
      center: true,
      minWidth: '100px',
      maxWidth: '130px',
    },
  ];

  const apprCandidatesColumns = [
  
    {
      name: 'Application Details',
      selector: (row) => row.Details,
      sortable: true,
      center: false,
      wrap: true,
      minWidth: '350px',
    },
    {
      name: 'Employee ID',
      selector: (row) => row.amount,
      sortable: true,
      center: true,
      minWidth: '100px',
      maxWidth: '150px',
    },
    {
      name: 'Amount',
      selector: (row) => row.stock,
      sortable: true,
      center: true,
      minWidth: '170px',
      maxWidth: '230px',
    },
    {
      name: 'Application Date',
      selector: (row) => row.start_date,
      sortable: true,
      center: true,
      minWidth: '150px',
      maxWidth: '150px',
    },
    {
      name: 'Action',
      selector: (row) => row.action,
      sortable: true,
      center: true,
      minWidth: '100px',
      maxWidth: '130px',
    },
  ];

   const SmallWidgetsData = [
    {
      title: 'Allocated Budget',
      color: 'success',
      total: parseInt(budgetNguidelines.allocated_budget),
      gros: 80,
      prefix: 'P',
      icon: 'profit',
    },
    {
      title: 'Qualifying Candidates',
      color: 'primary',
      total: parseInt(budgetNguidelines.qualifying_candidates),
      gros: 20,
      icon: 'new-order',
    },
    {
      title: 'Candidates Awarded',
      color: 'warning',
      total: parseInt(budgetNguidelines.approved_candidates),
      gros: 20,
      icon: 'customers',
    },
    {
      title: 'Amount Awarded ',
      color: 'warning',
      total: parseInt(budgetNguidelines.total_awarded),
      gros: 10,
      prefix: 'P',
      icon: 'sale',
      
    },
   
    {
      title: 'Rejected Candidates',
      color: 'secondary',
      total: parseInt(budgetNguidelines.rejected_candidates),
      gros: 10,
      prefix: '',
      icon: 'sale',
      
    },
    {
      title: 'Amount Remaining',
      color: 'secondary',
      total: parseInt(budgetNguidelines.allocated_budget)-parseInt(budgetNguidelines.total_awarded),
      gros: 80,
      prefix: 'P',
      icon: 'profit',
    },
  ];

  const bg = {
    overlay: {
      background: "#e9ecee"
    },
    background: "#e9ecee"
  };
  
   //alert('here'); 
    
  useEffect(() => {

   
    if(!isPrepopulatedDataIn){
    
      const body_t=JSON.stringify({
        
        omang:localStorage.getItem('username'),
        eng:'fetch_pinagare_supervisor_tasks',       
        
      });

      trackPromise(
          pinagareFetchRequest(pinagareAPIURL,body_t,'fetch_pinagare_supervisor_tasks')
      );  
  
    }

      
  }, [isPrepopulatedDataIn]);


  async function pinagareFetchRequest(url,body,eng) {
    try {
      await fetch(url, {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },
        body: body,
      })
        .then((respose) => {
          if (respose.ok) {
           
            return respose.json()
          }
          throw new Error('error')
        })
        .then((data) => {//alert('tasks d');

          
          if (data.status!=null&&data.status==true) {

         //alert(JSON.stringify(data)+'--- done');
            if(data.supervisorHasPendingTasks){

            setPinagareSupervisorTasks(data.tasks); //console.log(JSON.stringify(data.tasks));
            //setPinagareQualifyingCandidates(data.qualifying_candidates);
            initializeSupTasks(data.tasks);
              
            setIsPrepopulatedDataIn(true);

            //toast.success("Supervisor Tasks fetch Successful..."); 

            }
            else{

              //toast.error("No pending tasks...");

            }

            setIsPrepopulatedDataIn(true);

            if(data.isBoardChairperson!=null&&data.isBoardChairperson!=undefined)setIsBoardChairperson(data.isBoardChairperson);
            if(data.isBoardSecretary!=null&&data.isBoardSecretary!=undefined)setIsBoardSecretary(data.isBoardSecretary);
             

            let qcandid=0;
            let apprcandid=0;
            let rejcandid=0;
            let withdcandid=0;

            if(data.withdrawnCandidatesExist){//alert("tt");

            
              setPinagareWithdrawnCandidates(data.withdrawn_candidates);
              initializeWithdrawnCandidates(data.withdrawn_candidates);
                              
              withdcandid=data.withdrawn_candidates.length;
            }

            if(data.qualifyingCandidatesExist){//alert("tt");

            
              setPinagareQualifyingCandidates(data.qualifying_candidates);
              initializeQualifyingCandidates(data.qualifying_candidates);
                              
              qcandid=data.qualifying_candidates.length;
            }//else alert('none');

            if(data.approvedCandidatesExist){

             
               setPinagareApprovedCandidates(data.approved_candidates);
               initializeApprovedCandidates(data.approved_candidates); 
              
               apprcandid=data.approved_candidates.length;
             }//else alert('none');

             if(data.rejectedCandidatesExist){

           
               setPinagareRejectedCandidates(data.rejected_candidates);
               initializeRejectedCandidates(data.rejected_candidates);                 
               
               rejcandid=data.rejected_candidates.length;
             }//else alert('none');

             //alert(JSON.stringify(data.rejected_candidates));
             
             const thisBudgetNguidelines = {meeting_agenda_link:data.meeting_agenda_link,supporting_docs_link:data.supporting_docs_link,total_assessed_candidates_count:data.total_assessed_candidates_count,rejected_candidates_count:data.rejected_candidates_count,amount_remaining:data.amount_remaining,withdrawn_candidates_count:data.withdrawn_candidates_count,non_qualifying_candidates_count:data.non_qualifying_candidates_count, approved_candidates_count:data.approved_candidates_count,total_candidates_count:data.total_candidates_count,qualifying_candidates_count:data.qualifying_candidates_count, meeting_attendees:data.meeting_attendees,meeting_start_time:data.meeting_start_time,evaluation_concluded:data.evaluation_concluded,applicants_notified:data.applicants_notified,evaluation_meeting_ended:data.evaluation_meeting_ended,applications_period_ended:data.applications_period_ended,qualifying_mark:data.qualifying_mark,total_awarded:data.total_awarded,approved_candidates:apprcandid,rejected_candidates:rejcandid,qualifying_candidates:qcandid, allocated_budget: data.allocated_budget, evaluation_guidelines: data.evaluation_guidelines};
            
            setBudgetNguidelines(thisBudgetNguidelines);

           if(data.isCommitteeMember!=undefined&&data.isCommitteeMember!=null) setIsCommitteeMember(data.isCommitteeMember);

           if(data.isSecretariatOfficer!=undefined&&data.isSecretariatOfficer!=null) setIsSecretariatOfficer(data.isSecretariatOfficer);
                          
          } else {

            if (data.status!=null&&data.status==false) {
              //toast.error(data.message+" -- no tasks");
            }
            else{
              //toast.error("No pending tasks...");
            }

                       
                         
              setIsPrepopulatedDataIn(false);
         

          }
        })
    } catch (error) {
     
      toast.error("Making Data Fetch/Submit Request failed..."+JSON.stringify(error));
      
             
        setIsPrepopulatedDataIn(false);
     

    }
  }


   

var span1_content="";
var span1_content_candidates="";
var span1_content_appr_candidates="";
var span1_content_rej_candidates="";
var span1_content_withd_candidates="";

if(pinagareQualifyingCandidates!=null&&pinagareQualifyingCandidates.length>0){
  span1_content_candidates="Below is a list of all candidates who attained a score above the pass mark. The total number of such candidates is "+pinagareQualifyingCandidates.length+".";
}
else if(pinagareQualifyingCandidates==null||pinagareQualifyingCandidates.length<1){
  span1_content_candidates="No candidates who scored above the pass mark are awaiting evaluation!";
}

if(pinagareApprovedCandidates!=null&&pinagareApprovedCandidates.length>0){
  span1_content_appr_candidates="Below is a list of all candidates who are approved by the board. The total number of such candidates is "+pinagareApprovedCandidates.length+".";
}
else if(pinagareApprovedCandidates==null||pinagareApprovedCandidates.length<1){
  span1_content_appr_candidates="No approved candidates yet!!";
}

if(pinagareRejectedCandidates!=null&&pinagareRejectedCandidates.length>0){
  span1_content_rej_candidates="Below is a list of all candidates who are rejected by the board. The total number of such candidates is "+pinagareRejectedCandidates.length+".";
}
else if(pinagareRejectedCandidates==null||pinagareRejectedCandidates.length<1){
  span1_content_rej_candidates="No rejected candidates yet!!";
}

if(pinagareWithdrawnCandidates!=null&&pinagareWithdrawnCandidates.length>0){
  span1_content_withd_candidates="Below is a list of all candidates who have been withdrawn. The total number of such candidates is "+pinagareWithdrawnCandidates.length+".";
}
else if(pinagareWithdrawnCandidates==null||pinagareWithdrawnCandidates.length<1){
  span1_content_withd_candidates="No withdrawn candidates yet!!";
}

if(pinagareSupervisorTasks!=null&&pinagareSupervisorTasks.length>0){
  span1_content="Below is a list of supervisory tasks that require your attention.";
}
else if(pinagareSupervisorTasks==null||pinagareSupervisorTasks.length<1){
  span1_content="No tasks require your attention at this time.";
}


const initializeSupTasks = (thisSupervisorTasks) => {

  let templateTaskData=null;
  let newListo = [];
       

if(thisSupervisorTasks!=null&&thisSupervisorTasks.length>0){

let thisMaxi=supTasksPerPage > thisSupervisorTasks.length? thisSupervisorTasks.length:supTasksPerPage;

for(let i=0;i<thisMaxi;i++){
   
    templateTaskData =    {
     
      Details: (
        <div>
          <H6>{thisSupervisorTasks[i].names}</H6>
          <span>{thisSupervisorTasks[i].scheme}</span>
        </div>
      ),
      amount: thisSupervisorTasks[i].amount,
      stock: <div className='font-success'>{thisSupervisorTasks[i].current_status}</div>,
      start_date: thisSupervisorTasks[i].application_date,
      action: (
        <div>              
          <span>
            <Link to={`${process.env.PUBLIC_URL}/dpsm/scheme/review-application/ltp/`+thisSupervisorTasks[i].application_id}>                          
               <Btn attrBtn={{ style: style2, color: 'success', className: 'btn', type: 'button' }}> Review </Btn>                
            </Link>
          </span>
        </div>
      ),
    }


   if(templateTaskData!=null) newListo = [...newListo, templateTaskData];
               

}

setSupTasksItems(newListo);
setSupTasksTotalRows(thisSupervisorTasks.length);

}

}

const initializeQualifyingCandidates = (thisPinagareData) => {

  let templateTaskData=null;
  let newListo = [];
       

if(thisPinagareData!=null&&thisPinagareData.length>0){

let thisMaxi=qualifyingCandPerPage > thisPinagareData.length? thisPinagareData.length:qualifyingCandPerPage;

for(let i=0;i<thisMaxi;i++){
   
  templateTaskData =    {
         
    Details: (
      <div>
        <H6>{thisPinagareData[i].names}</H6>
        <span>{thisPinagareData[i].scheme}</span>
      </div>
    ),
    amount: thisPinagareData[i].amount,
    stock: <div className='font-success'>{thisPinagareData[i].score}</div>,
    start_date: thisPinagareData[i].application_date,
    action: (
      <div>              
        <span>
          <Link to={`${process.env.PUBLIC_URL}/dpsm/scheme/review-application/ltp/`+thisPinagareData[i].application_id}>                          
             <Btn attrBtn={{ style: style2, color: 'success', className: 'btn', type: 'button' }}> Review </Btn>                
          </Link>
        </span>
      </div>
    ),
  }


   if(templateTaskData!=null) newListo = [...newListo, templateTaskData];
               

}

setQualifyingCandItems(newListo);
setQualifyingCandTotalRows(thisPinagareData.length);

}

}

const initializeWithdrawnCandidates = (thisPinagareData) => {

  let templateTaskData=null;
  let newListo = [];
       

if(thisPinagareData!=null&&thisPinagareData.length>0){

let thisMaxi=withdrawnCandPerPage > thisPinagareData.length? thisPinagareData.length:withdrawnCandPerPage;

for(let i=0;i<thisMaxi;i++){
   
    templateTaskData =    {
     
      Details: (
        <div>
          <H6>{thisPinagareData[i].names}</H6>
          <span>{thisPinagareData[i].scheme}</span>
        </div>
      ),
      amount: thisPinagareData[i].amount,
      stock: <div className='font-success'>{thisPinagareData[i].score}</div>,
      start_date: thisPinagareData[i].application_date,
      action: (
        <div>              
          <span>
            <Link to={`${process.env.PUBLIC_URL}/dpsm/scheme/review-application/ltp/`+thisPinagareData[i].application_id}>                          
               <Btn attrBtn={{ style: style2, color: 'success', className: 'btn', type: 'button' }}> View </Btn>                
            </Link>
          </span>
        </div>
      ),
    }


   if(templateTaskData!=null) newListo = [...newListo, templateTaskData];
               

}

setWithdrawnCandItems(newListo);
setWithdrawnCandTotalRows(thisPinagareData.length);

}

}

const initializeApprovedCandidates = (thisPinagareData) => {

  let templateTaskData=null;
  let newListo = [];
       

if(thisPinagareData!=null&&thisPinagareData.length>0){

let thisMaxi=approvedCandPerPage > thisPinagareData.length? thisPinagareData.length:approvedCandPerPage;

for(let i=0;i<thisMaxi;i++){
   
    templateTaskData =    {
     
      Details: (
        <div>
          <H6>{thisPinagareData[i].names}</H6>
          <span>{thisPinagareData[i].scheme}</span>
        </div>
      ),
      amount: thisPinagareData[i].amount,
      stock: <div className='font-success'>{thisPinagareData[i].score}</div>,
      start_date: thisPinagareData[i].application_date,
      action: (
        <div>              
          <span>
            <Link to={`${process.env.PUBLIC_URL}/dpsm/scheme/review-application/ltp/`+thisPinagareData[i].application_id}>                          
               <Btn attrBtn={{ style: style2, color: 'success', className: 'btn', type: 'button' }}> Review </Btn>                
            </Link>
          </span>
        </div>
      ),
    }


   if(templateTaskData!=null) newListo = [...newListo, templateTaskData];
               

}

setApprovedCandItems(newListo);
setApprovedCandTotalRows(thisPinagareData.length);

}

}

const initializeRejectedCandidates = (thisPinagareData) => {

  let templateTaskData=null;
  let newListo = [];
       

if(thisPinagareData!=null&&thisPinagareData.length>0){

let thisMaxi=rejectedCandPerPage > thisPinagareData.length? thisPinagareData.length:rejectedCandPerPage;

for(let i=0;i<thisMaxi;i++){
   
    templateTaskData =    {
     
      Details: (
        <div>
          <H6>{thisPinagareData[i].names}</H6>
          <span>{thisPinagareData[i].scheme}</span>
        </div>
      ),
      amount: thisPinagareData[i].amount,
      stock: <div className='font-success'>{thisPinagareData[i].score}</div>,
      start_date: thisPinagareData[i].application_date,
      action: (
        <div>              
          <span>
            <Link to={`${process.env.PUBLIC_URL}/dpsm/scheme/review-application/ltp/`+thisPinagareData[i].application_id}>                          
               <Btn attrBtn={{ style: style2, color: 'success', className: 'btn', type: 'button' }}> Review </Btn>                
            </Link>
          </span>
        </div>
      ),
    }


   if(templateTaskData!=null) newListo = [...newListo, templateTaskData];
               

}

setRejectedCandItems(newListo);
setRejectedCandTotalRows(thisPinagareData.length);

}

}



const handleSupTasksPageChange = (page) => {
  
  
  let templateTaskData=null;
        let newListo = [];        
        let thisMax=page*supTasksPerPage;
        let thisMin=thisMax-supTasksPerPage;

  if(isPrepopulatedDataIn&&pinagareSupervisorTasks!=null&&pinagareSupervisorTasks.length>0){

  if(thisMax > pinagareSupervisorTasks.length){
    thisMax=pinagareSupervisorTasks.length;
    thisMin=pinagareSupervisorTasks.length-supTasksPerPage;
  }

  if(thisMax < supTasksPerPage)thisMin=0;

for(let i=thisMin;i<thisMax;i++){
   
    templateTaskData =    {
     
      Details: (
        <div>
          <H6>{pinagareSupervisorTasks[i].names}</H6>
          <span>{pinagareSupervisorTasks[i].scheme}</span>
        </div>
      ),
      amount: pinagareSupervisorTasks[i].amount,
      stock: <div className='font-success'>{pinagareSupervisorTasks[i].current_status}</div>,
      start_date: pinagareSupervisorTasks[i].application_date,
      action: (
        <div>              
          <span>
            <Link to={`${process.env.PUBLIC_URL}/dpsm/scheme/review-application/ltp/`+pinagareSupervisorTasks[i].application_id}>                          
               <Btn attrBtn={{ style: style2, color: 'success', className: 'btn', type: 'button' }}> Review </Btn>                
            </Link>
          </span>
        </div>
      ),
    }


   if(templateTaskData!=null) newListo = [...newListo, templateTaskData];
               

}

setSupTasksItems(newListo);

}
}

const handleQualifyingCandPageChange = (page) => {
  
  
  let templateTaskData=null;
        let newListo = [];        
        let thisMax=page*qualifyingCandPerPage;
        let thisMin=thisMax-qualifyingCandPerPage;

  if(isPrepopulatedDataIn&&pinagareQualifyingCandidates!=null&&pinagareQualifyingCandidates.length>0){

  if(thisMax > pinagareQualifyingCandidates.length){
    thisMax=pinagareQualifyingCandidates.length;
    thisMin=pinagareQualifyingCandidates.length-qualifyingCandPerPage;
  }

  if(thisMax < qualifyingCandPerPage)thisMin=0;

for(let i=thisMin;i<thisMax;i++){
   
  templateTaskData =    {
         
    Details: (
      <div>
        <H6>{pinagareQualifyingCandidates[i].names}</H6>
        <span>{pinagareQualifyingCandidates[i].scheme}</span>
      </div>
    ),
    amount: pinagareQualifyingCandidates[i].amount,
    stock: <div className='font-success'>{pinagareQualifyingCandidates[i].score}</div>,
    start_date: pinagareQualifyingCandidates[i].application_date,
    action: (
      <div>              
        <span>
          <Link to={`${process.env.PUBLIC_URL}/dpsm/scheme/review-application/ltp/`+pinagareQualifyingCandidates[i].application_id}>                          
             <Btn attrBtn={{ style: style2, color: 'success', className: 'btn', type: 'button' }}> Review </Btn>                
          </Link>
        </span>
      </div>
    ),
  }


   if(templateTaskData!=null) newListo = [...newListo, templateTaskData];
               

}

setQualifyingCandItems(newListo);

}
}

const handleApprovedCandPageChange = (page) => {
  
  
  let templateTaskData=null;
        let newListo = [];        
        let thisMax=page*approvedCandPerPage;
        let thisMin=thisMax-approvedCandPerPage;

  if(isPrepopulatedDataIn&&pinagareApprovedCandidates!=null&&pinagareApprovedCandidates.length>0){

  if(thisMax > pinagareApprovedCandidates.length){
    thisMax=pinagareApprovedCandidates.length;
    thisMin=pinagareApprovedCandidates.length-approvedCandPerPage;
  }

  if(thisMax < approvedCandPerPage)thisMin=0;

for(let i=thisMin;i<thisMax;i++){
   
  templateTaskData =    {
         
    Details: (
      <div>
        <H6>{pinagareApprovedCandidates[i].names}</H6>
        <span>{pinagareApprovedCandidates[i].scheme}</span>
      </div>
    ),
    amount: pinagareApprovedCandidates[i].amount,
    stock: <div className='font-success'>{pinagareApprovedCandidates[i].score}</div>,
    start_date: pinagareApprovedCandidates[i].application_date,
    action: (
      <div>              
        <span>
          <Link to={`${process.env.PUBLIC_URL}/dpsm/scheme/review-application/ltp/`+pinagareApprovedCandidates[i].application_id}>                          
             <Btn attrBtn={{ style: style2, color: 'success', className: 'btn', type: 'button' }}> Review </Btn>                
          </Link>
        </span>
      </div>
    ),
  }


   if(templateTaskData!=null) newListo = [...newListo, templateTaskData];
               

}

setApprovedCandItems(newListo);

}
}

const handleRejectedCandPageChange = (page) => {
  
  
  let templateTaskData=null;
        let newListo = [];        
        let thisMax=page*rejectedCandPerPage;
        let thisMin=thisMax-rejectedCandPerPage;

  if(isPrepopulatedDataIn&&pinagareRejectedCandidates!=null&&pinagareRejectedCandidates.length>0){

  if(thisMax > pinagareRejectedCandidates.length){
    thisMax=pinagareRejectedCandidates.length;
    thisMin=pinagareRejectedCandidates.length-rejectedCandPerPage;
  }

  if(thisMax < rejectedCandPerPage)thisMin=0;

for(let i=thisMin;i<thisMax;i++){
   
  templateTaskData =    {
         
    Details: (
      <div>
        <H6>{pinagareRejectedCandidates[i].names}</H6>
        <span>{pinagareRejectedCandidates[i].scheme}</span>
      </div>
    ),
    amount: pinagareRejectedCandidates[i].amount,
    stock: <div className='font-success'>{pinagareRejectedCandidates[i].score}</div>,
    start_date: pinagareRejectedCandidates[i].application_date,
    action: (
      <div>              
        <span>
          <Link to={`${process.env.PUBLIC_URL}/dpsm/scheme/review-application/ltp/`+pinagareRejectedCandidates[i].application_id}>                          
             <Btn attrBtn={{ style: style2, color: 'success', className: 'btn', type: 'button' }}> Review </Btn>                
          </Link>
        </span>
      </div>
    ),
  }


   if(templateTaskData!=null) newListo = [...newListo, templateTaskData];
               

}

setRejectedCandItems(newListo);

}
}

const handleWithdrawnCandPageChange = (page) => {
  
  
  let templateTaskData=null;
        let newListo = [];        
        let thisMax=page*withdrawnCandPerPage;
        let thisMin=thisMax-withdrawnCandPerPage;

  if(isPrepopulatedDataIn&&pinagareWithdrawnCandidates!=null&&pinagareWithdrawnCandidates.length>0){

  if(thisMax > pinagareWithdrawnCandidates.length){
    thisMax=pinagareWithdrawnCandidates.length;
    thisMin=pinagareWithdrawnCandidates.length-withdrawnCandPerPage;
  }

  if(thisMax < withdrawnCandPerPage)thisMin=0;

for(let i=thisMin;i<thisMax;i++){
   
  templateTaskData =    {
         
    Details: (
      <div>
        <H6>{pinagareWithdrawnCandidates[i].names}</H6>
        <span>{pinagareWithdrawnCandidates[i].scheme}</span>
      </div>
    ),
    amount: pinagareWithdrawnCandidates[i].amount,
    stock: <div className='font-success'>{pinagareWithdrawnCandidates[i].score}</div>,
    start_date: pinagareWithdrawnCandidates[i].application_date,
    action: (
      <div>              
        <span>
          <Link to={`${process.env.PUBLIC_URL}/dpsm/scheme/review-application/ltp/`+pinagareWithdrawnCandidates[i].application_id}>                          
             <Btn attrBtn={{ style: style2, color: 'success', className: 'btn', type: 'button' }}> View </Btn>                
          </Link>
        </span>
      </div>
    ),
  }


   if(templateTaskData!=null) newListo = [...newListo, templateTaskData];
               

}

setWithdrawnCandItems(newListo);

}
}

const handleSupTasksPerRowsChange = async (newPerPage, page) => { 
  setSupTasksPerPage(newPerPage);
}

const handleQualifyingCandPerRowsChange = async (newPerPage, page) => { 
  setQualifyingCandPerPage(newPerPage);
}

const handleApprovedCandPerRowsChange = async (newPerPage, page) => { 
  setApprovedCandPerPage(newPerPage);
}

const handleRejectedCandPerRowsChange = async (newPerPage, page) => { 
  setRejectedCandPerPage(newPerPage);
}

const handleWithdrawnCandPerRowsChange = async (newPerPage, page) => { 
  setWithdrawnCandPerPage(newPerPage);
}

useEffect(() => {
 
  handleSupTasksPageChange(1);
  handleQualifyingCandPageChange(1);
  handleApprovedCandPageChange(1);
  handleRejectedCandPageChange(1);
  handleWithdrawnCandPageChange(1);

}, [supTasksPerPage,qualifyingCandPerPage,withdrawnCandItems,approvedCandPerPage,rejectedCandPerPage]);

let toggi={"progressStatusToggle":toggle,"notifyApplicantsToggle":toggle2,"boardPackToggle":toggle3,
          "qualifyingMarkToggle":qualifyingMarkToggle, "pinagareMeetingToggle":startMeetingToggle,
          "applicationPeriodToggle":applicationPeriodToggle,"withdrawApplicationToggle":withdrawApplicationToggle,
           "searchApplicationToggle":searchApplicationToggle};

    return ( 

      
        <Fragment> 
            {isSecretariatOfficer? (<Breadcrumbs schemeParameters={budgetNguidelines} thisToggle={toggi} eng="secretariat" parent="Home" title="" mainTitle="Supervisor Tasks" />):(
             isBoardChairperson||isBoardSecretary? (<Breadcrumbs schemeParameters={budgetNguidelines} thisToggle={toggi} eng="chairperson" parent="Home" title="" mainTitle="Supervisor Tasks" />):(
             <Breadcrumbs  eng="none" parent="Home" title="Supervisor Tasks" mainTitle="Supervisor Tasks" /> )
            )}
            <Container fluid={true}>

            
              {budgetNguidelines!=null&&budgetNguidelines.evaluation_meeting_ended!=undefined&&!budgetNguidelines.evaluation_meeting_ended? ( <Row>
                    <Col sm="12">
                    <BoardMeetingPanel meetingParameters={budgetNguidelines} pinagareMeetingToggle={startMeetingToggle} />
                    </Col>
                </Row>):null}
            
        {isCommitteeMember||isSecretariatOfficer? (<Row className="project-card">
          <Col md="12" className="project-list">
            <Card>
              <Row >
                <Col md="3">
                  <Nav tabs className="border-tab">
                    
                    <NavItem><NavLink className={'active'} ><H5><CheckCircle />{"Evaluation Menu:"}</H5></NavLink></NavItem>                    
				            </Nav>
                </Col>

                <Col md="3">
                 
                </Col>

                <Col md="3">
                  <div className="text-end"> 
                    {/*<Link attrBtn={{ color: 'primary', className: 'me-3'}} onClick={toggle} className="btn btn-primary" style={{ color: 'white' }} > {"Evaluation Guidlines"}</Link>*/}
                     <Btn attrBtn={{ color: 'primary', className: 'me-3' , onClick: toggle}} className="btn btn-primary" style={{ color: 'white' }}>{"Evaluation Progress"}</Btn>						 
                 {budgetNguidelines!==null? ( 
                 <CommonModal styles={bg} isOpen={modal} title={"Evaluation Progress Status"} toggler={toggle} closeBtnTxt={"Close"} disableSaveBtn={true}  >
                   <hr />

                   <Row className="page-body-wrapper" style={{"background":"#e9ecee"}} >{SmallWidgetsData.map((data, i) => (
          data.title=='Allocated Budget'||data.title=="Amount Remaining"? (<Col xs='12' key={i}><br />
          <SmallWidgets data={data} />  
        </Col>):(<Col xs='6' key={i}><br />
            <SmallWidgets data={data} />  
          </Col>)
        ))}</Row>
                    
                 </CommonModal> 
                  
                  ):null}
                  </div>
                </Col>

                			
				       {isSecretariatOfficer||isCommitteeMember?( <Col md="3">
                  <div className="text-end">
                   {/*} <Link to={`${process.env.PUBLIC_URL}/dpsm/home/my-applications`} className="btn btn-primary" style={{ color: 'white' }} > {"Conclude Evaluation"}</Link>*/}
                    <Btn attrBtn={{ color: 'primary', className: 'me-3' , onClick: viewBoardPackToggle}} className="btn btn-primary" style={{ color: 'white' }}>{"View Board Pack"}</Btn>						 
                 {budgetNguidelines!==null? ( 
                 
        <Modal className='modal-bookmark' isOpen={modal2} toggle={toggle2} size='lg'>
        <ModalHeader toggle={toggle2}>{"Notify Applicants"}</ModalHeader>
        <ModalBody>
          <Form className='form-bookmark needs-validation' onSubmit={handleSubmit2(onSubmit2)}>
            <div className='form-row'>
              
			  <FormGroup className='col-md-12'>
                <Label><H6>{"Send Notification Emails: "}</H6></Label>
               
	  <select className='form-control' name="target_email_group" {...register2('target_email_group', { required: true })}>

      <option value="">Select</option>
        <option value="successful_candidates">Successful Candidates Only</option>
        <option value="unsuccessful_candidates">Unsuccessful Candidates Only</option>        
      </select>
	  
                <span style={{ color: 'red' }}>{errors2.target_email_group && 'Please select target group'}</span>
              
			  </FormGroup>
			              
			</div>
            <Btn attrBtn={{ color: 'primary', className: 'me-2' }}>{"Send"}</Btn>
            <Btn attrBtn={{ color: 'secondary', onClick: toggle2 }}>{"Back"}</Btn>
          </Form>
        </ModalBody>
      </Modal>
                  
                  ):null}
                  </div>
                </Col>):null}
               
              </Row>
            </Card>
            </Col>
            </Row>):null}


            {isCommitteeMember||isSecretariatOfficer? (<Row className="project-card">
            <Col md="12" className="project-list">
           

            <Row>
                    <Col sm="12">
                        <Card>
                            <HeaderCard  pdfdata={pinagareQualifyingCandidates} title={" Qualifying Candidates"} span1={span1_content_candidates} eng={"qualifying_candidates"} />
                            <CardBody>
                               { pinagareQualifyingCandidates!=null&&pinagareQualifyingCandidates.length>0 ?                                  
                               (isPrepopulatedDataIn && <DataTable noHeader pagination paginationServer paginationPerPage={qualifyingCandPerPage} onChangeRowsPerPage={handleQualifyingCandPerRowsChange} onChangePage={handleQualifyingCandPageChange}  paginationTotalRows={qualifyingCandTotalRows} paginationRowsPerPageOptions={[5, 10, 20, 50, 100]} columns={qCandidatesColumns} data={qualifyingCandItems} highlightOnHover={true} striped={true} responsive={true} />
                               ): "No candidates scored above the pass mark!" } 
      
                            </CardBody>
                        </Card>
                    </Col>
                </Row>

               
                </Col>
                </Row>):null}

                {isCommitteeMember||isSecretariatOfficer? (<Row className="project-card">
            <Col md="12" className="project-list">
           

            <Row>
                    <Col sm="12">
                        <Card>
                            <HeaderCard pdfdata={pinagareApprovedCandidates} title={" Approved Candidates"} span1={span1_content_appr_candidates} eng={"approved_candidates"} />
                            <CardBody>
                               { pinagareApprovedCandidates!=null&&pinagareApprovedCandidates.length>0 ?                                  
                               (isPrepopulatedDataIn && <DataTable noHeader pagination paginationServer paginationPerPage={approvedCandPerPage} onChangeRowsPerPage={handleApprovedCandPerRowsChange} onChangePage={handleApprovedCandPageChange}  paginationTotalRows={approvedCandTotalRows} paginationRowsPerPageOptions={[5, 10, 20, 50, 100]} columns={apprCandidatesColumns} data={approvedCandItems} highlightOnHover={true} striped={true} responsive={true} />
                               ): "No approved candidates yet" }
      
                            </CardBody>
                        </Card>
                    </Col>
                </Row>

               
                </Col>
                </Row>):null}

                {isCommitteeMember||isSecretariatOfficer? (<Row className="project-card">
            <Col md="12" className="project-list">
           

            <Row>
                    <Col sm="12">
                        <Card>
                            <HeaderCard  pdfdata={pinagareRejectedCandidates} title={" Rejected Candidates"} span1={span1_content_rej_candidates} eng={"rejected_candidates"} />
                            <CardBody>
                               { pinagareRejectedCandidates!=null&&pinagareRejectedCandidates.length>0 ?                                  
                               (isPrepopulatedDataIn && <DataTable noHeader pagination paginationServer paginationPerPage={rejectedCandPerPage} onChangeRowsPerPage={handleRejectedCandPerRowsChange} onChangePage={handleRejectedCandPageChange}  paginationTotalRows={rejectedCandTotalRows} paginationRowsPerPageOptions={[5, 10, 20, 50, 100]} columns={qCandidatesColumns} data={rejectedCandItems} highlightOnHover={true} striped={true} responsive={true} />
                               ): "No rejected candidates yet" }
      
                            </CardBody>
                        </Card>
                    </Col>
                </Row>

               
                </Col>
                </Row>):null}

                {isCommitteeMember||isSecretariatOfficer? (<Row className="project-card">
            <Col md="12" className="project-list">
           

            <Row>
                    <Col sm="12">
                        <Card>
                            <HeaderCard  pdfdata={pinagareWithdrawnCandidates} title={" Withdrawn Applications"} span1={span1_content_withd_candidates} eng={"withdrawn_applications"} />
                            <CardBody>
                               { pinagareWithdrawnCandidates!=null&&pinagareWithdrawnCandidates.length>0 ?                                  
                               (isPrepopulatedDataIn && <DataTable noHeader pagination paginationServer paginationPerPage={withdrawnCandPerPage} onChangeRowsPerPage={handleWithdrawnCandPerRowsChange} onChangePage={handleWithdrawnCandPageChange}  paginationTotalRows={withdrawnCandTotalRows} paginationRowsPerPageOptions={[5, 10, 20, 50, 100]} columns={qCandidatesColumns} data={withdrawnCandItems} highlightOnHover={true} striped={true} responsive={true} />
                               ): "No withdrawn applications yet" }
      
                            </CardBody>
                        </Card>
                    </Col>
                </Row>

               
                </Col>
                </Row>):null}

                <Row>
                    <Col sm="12">
                        <Card>
                            <HeaderCard title={" Pending Tasks"} span1={span1_content} eng={"pending"} />
                            <CardBody>
                               { pinagareSupervisorTasks!=null&&pinagareSupervisorTasks.length>0 ?                                  
                               (isPrepopulatedDataIn && <DataTable noHeader pagination paginationServer paginationPerPage={supTasksPerPage} onChangeRowsPerPage={handleSupTasksPerRowsChange} onChangePage={handleSupTasksPageChange}  paginationTotalRows={supTasksTotalRows} paginationRowsPerPageOptions={[5, 10, 20, 50, 100]}  columns={productColumns} data={supTasksItems} highlightOnHover={true} striped={true} responsive={true} />
                               ): "No pending tasks!" }
      
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
				
                {isSecretariatOfficer? (
                  <Row>
                  <Col md="6">
                  <div className="text-end"> 
                    {/*<Link attrBtn={{ color: 'primary', className: 'me-3'}} onClick={toggle} className="btn btn-primary" style={{ color: 'white' }} > {"Evaluation Guidlines"}</Link>*/}
                     {/*<Btn attrBtn={{ color: 'primary', className: 'me-3' , onClick: toggle3}} className="btn btn-primary" style={{ color: 'white' }}>{"Update Guidelines"}</Btn>*/}						 
                 
                
                 <Modal className='modal-bookmark' isOpen={modal3} toggle={toggle3} size='lg'>
                 <ModalHeader toggle={toggle3}>{"Create Board Pack"}</ModalHeader>
                 <ModalBody>
                 <PromiseSpinner />
                   <Form className='form-bookmark needs-validation' onSubmit={(e) => {handleSubmit(onSubmit)(e)}}>
                     <div className='form-row'>
                       
                       <FormGroup className='col-md-12'>
                         <Label><H6>{"Allocated Budget: "}</H6></Label>
                         <Row>
                           <Col sm='8'>
                             <input style={{border:"2px solid #6ec6ec"}} className='form-control input_bodara' defaultValue={budgetNguidelines.allocated_budget} name='budget' type='text' {...register('budget', { required: true })} />
                             <span style={{ color: 'red' }}>{errors.budget && 'Allocated budget is required'}</span>
                           </Col>                  
                         </Row>
                       </FormGroup> 
                     
                       <FormGroup className='col-md-12'>
                         <Label><H6>{"Evaluation Meeting Agenda: "}</H6></Label>
                         <Row>
                           <Col sm='8'>
                             <SingleFileUploader eng={"meeting_agenda"} />
                           </Col>                  
                         </Row>
                       </FormGroup> 
                       <FormGroup className='col-md-12'>
                         <Label><H6>{"Any Supporting Document (Optional): "}</H6></Label>
                         <Row>
                           <Col sm='8'>
                              <SingleFileUploader eng={"supporting_documents"}/>
                           </Col>                  
                         </Row>
                       </FormGroup> 
                       
                 <FormGroup className='col-md-12'>
                         <Label><H6>{"Evaluation Guidelines: "}</H6></Label>
                         <Row>
                           <Col sm='8'>	  
                           <textarea style={{border:"2px solid #6ec6ec"}} className='form-control' name="evaluation_guidelines" rows="4" cols="100" {...register('evaluation_guidelines', { required: true })}>
                           {budgetNguidelines.evaluation_guidelines}
                           </textarea>	  
                           <span style={{ color: 'red' }}>{errors.evaluation_guidelines && 'Please add the evaluation guidelines'}</span>
                         </Col>                  
                     </Row>
                 </FormGroup>
                 
                     
               </div>
                     <Btn type="Submit" attrBtn={{ color: 'primary', className: 'me-2' }}>{"Save"}</Btn>
                     <Btn attrBtn={{ color: 'secondary', onClick: toggle3 }}>{"Back"}</Btn>
                   </Form>
                 </ModalBody>
               </Modal>
                  
                  
                  </div>
                </Col></Row>) : null
                }

                {isCommitteeMember||isSecretariatOfficer? ( <Col md="6">
                  <div className="text-end"> 
                    
                
                 <Modal className='modal-bookmark' isOpen={viewBoardPackModal} toggle={viewBoardPackToggle} size='lg'>
                 <ModalHeader toggle={viewBoardPackToggle}>{"Board Pack"}</ModalHeader>
                 <ModalBody>
                   <Form className='form-bookmark needs-validation' >
                     <div className='form-row'>
                       
                     <FormGroup className='col-md-12'>
                         <Label><H6>{"Allocated Budget: "}</H6></Label> 
                         <Row>
                           <Col sm='8'>
                           {budgetNguidelines.allocated_budget}
                              </Col>                  
                         </Row>
                       </FormGroup> 
                     
                       <FormGroup className='col-md-12'>
                         <Label><H6>{"Evaluation Meeting Agenda: "}</H6></Label>
                         <Row>
                           <Col sm='8'>                             
                          {budgetNguidelines.meeting_agenda_link!=undefined&&budgetNguidelines.meeting_agenda_link!=null? (<a href={pinagareFilesUpload+budgetNguidelines.meeting_agenda_link} target="_blank"><H6>{"View as PDF"}</H6></a>):"No Meeting Agenda"}
                           </Col>                  
                         </Row>
                       </FormGroup> 
                       <FormGroup className='col-md-12'>
                         <Label><H6>{"Supporting Document: "}</H6></Label>
                         <Row>
                           <Col sm='8'>
                           {budgetNguidelines.supporting_docs_link!=undefined&&budgetNguidelines.supporting_docs_link!=null? (<a href={pinagareFilesUpload+budgetNguidelines.supporting_docs_link} target="_blank"><H6>{"View as PDF"}</H6></a>):"No Supporting Document Uploaded"}
                           </Col>                  
                         </Row>
                       </FormGroup> 
                       
                 <FormGroup className='col-md-12'>
                         <Label><H6>{"Evaluation Guidelines: "}</H6></Label>
                         <Row>
                           <Col sm='8'>	  
                           {budgetNguidelines.evaluation_guidelines}
                         </Col>                  
                     </Row>
                 </FormGroup>
                     
                                            
               </div>
                     
                     <Btn attrBtn={{ color: 'secondary', onClick: viewBoardPackToggle }}>{"Back"}</Btn>
                   </Form>
                 </ModalBody>
               </Modal>
                  
                  
                  </div>
                </Col>):null}

             {isSecretariatOfficer||isBoardChairperson||isBoardSecretary? (
                  <Row>
                  <Col md="6">
                  <div className="text-end"> 
                    
                
                 <Modal className='modal-bookmark' isOpen={qualifyingMarkModal} toggle={qualifyingMarkToggle} size='lg'>
                 <ModalHeader toggle={qualifyingMarkToggle}>{"Change Qualifying Mark"}</ModalHeader>
                 <ModalBody>
                   <Form className='form-bookmark needs-validation' onSubmit={(e) => {handleSubmit3(onSubmit3)(e)}}>
                     <div className='form-row'>
                       
                       <FormGroup className='col-md-12'>
                         <Label><H6>{"Qualifying Mark: "}</H6></Label>
                         <Row>
                           <Col sm='8'>
                             <input className='form-control' defaultValue={budgetNguidelines.qualifying_mark} name='qualifying_mark' type='text' {...register3('qualifying_mark', { required: true })} />
                             <span style={{ color: 'red' }}>{errors3.qualifying_mark && 'Qualifying mark is required'}</span>
                           </Col>                  
                         </Row>
                       </FormGroup> 
                     
                                            
               </div>
                     <Btn type="Submit" attrBtn={{ color: 'primary', className: 'me-2' }}>{"Update"}</Btn>
                     <Btn attrBtn={{ color: 'secondary', onClick: qualifyingMarkToggle }}>{"Back"}</Btn>
                   </Form>
                 </ModalBody>
               </Modal>
                  
                  
                  </div>
                </Col>
                
                <Col md="6">
                  <div className="text-end"> 
                    
                
                 <Modal className='modal-bookmark' isOpen={startMeetingModal} toggle={startMeetingToggle} size='lg'>
                 {budgetNguidelines!=null&&budgetNguidelines.evaluation_meeting_ended!=undefined&&budgetNguidelines.evaluation_meeting_ended? ( 
                  <span>
                 <ModalHeader toggle={startMeetingToggle}>{"Starting Evaluation Meeting"}</ModalHeader>
                 <ModalBody>
                   <Form className='form-bookmark needs-validation' onSubmit={(e) => {handleSubmit4(onSubmit4)(e)}}>
                     <div className='form-row'>
                       
                       <FormGroup className='col-md-12'>
                         
                         <Row>
                           <Col sm='8'>
                           
                           <div className='m-t-15 m-checkbox-inline custom-radio-ml'>
                           <Label><H6>{"Any Apologies?: "}</H6></Label>
                        <div className='radio radio-primary'  style={{"paddingLeft":"10px"}}>

                          <input className='form-control' onClick={handleInputClickP} defaultValue={"yes"} name='any_meeting_apologies'  id='any_meeting_apologies_radio1' type='radio' {...register4('any_meeting_apologies', { required: true })} />
                            
                          <Label className='mb-0' for='any_meeting_apologies_radio1'>
                             {"Yes "}                  
                          </Label>
                        </div>
                                   
                        <div className='radio radio-primary'  style={{"paddingLeft":"10px"}}>
                        <input className='form-control' onClick={handleInputClickP} defaultValue={"no"} name='any_meeting_apologies'  id='any_meeting_apologies_radio2' type='radio' {...register4('any_meeting_apologies', { required: true })} />
                         <Label className='mb-0' for='any_meeting_apologies_radio2'>
                            {"No"}                 
                          </Label>
                        </div>
                        <span style={{ color: 'red' }}>{errors4.any_meeting_apologies && 'You must state whether there are any apologies or not.'}</span>
                      </div>

                      {anyMeetingApologies? (<div >
                      <hr />
                   
                      <FormGroup className='col-md-12'>
                         <Label><H6>{"Omang 1: "}</H6></Label>
                         <Row>
                           <Col sm='8'>
                             <input className='form-control' name='apology_omang1' type='text' {...register4('apology_omang1', { required: true })} />
                             <span style={{ color: 'red' }}>{errors4.apology_omang1 && 'Omang of absent member required'}</span>
                           </Col>                  
                         </Row>
                         <Label><H6>{"Omang 2: (Optional)"}</H6></Label>
                         <Row>
                           <Col sm='8'>
                             <input className='form-control' name='apology_omang2' type='text' {...register4('apology_omang2', { required: false })} />
                            
                           </Col>                  
                         </Row>
                       </FormGroup>
                     
                     </div>):null}

                           </Col>                  
                         </Row>
                       </FormGroup> 
                     
                                    
                     
               </div>
                     <Btn type="Submit" attrBtn={{ color: 'primary', className: 'me-2' }}>{"Start Meeting"}</Btn>
                     <Btn attrBtn={{ color: 'secondary', onClick: startMeetingToggle }}>{"Back"}</Btn>
                   </Form>
                 </ModalBody>
                </span>
                 ):(
                  <span>
                  <ModalHeader toggle={startMeetingToggle}>{"End Evaluation Meeting"}</ModalHeader>
                  <ModalBody>
                  <Form className='form-bookmark needs-validation' onSubmit={(e) => {handleSubmit4(onSubmit4)(e)}}>
                     <div className='form-row'>
                     {"Are you sure you want to end this meeting?"}
                     <br /><br />
                     </div>
                     <Btn type="Submit" attrBtn={{ color: 'primary', className: 'me-2' }}>{"End Meeting"}</Btn>
                     <Btn attrBtn={{ color: 'secondary', onClick: startMeetingToggle }}>{"Back"}</Btn>
                   </Form>
                 </ModalBody>
                </span>
                 )}
               </Modal>
                  
                  
                  </div>
                </Col>


                <Col md="6">
                  <div className="text-end"> 
                    
                  {budgetNguidelines!=null&&budgetNguidelines.applications_period_ended!=undefined&&budgetNguidelines.applications_period_ended? ( 
                  <span>
                 <Modal className='modal-bookmark' isOpen={applicationPeriodModal} toggle={applicationPeriodToggle} size='lg'>
                 <ModalHeader toggle={applicationPeriodToggle}>{"Start Application Period"}</ModalHeader>
                 <ModalBody>
                   <Form className='form-bookmark needs-validation' onSubmit={(e) => {handleSubmit5(onSubmit5)(e)}}>
                     <div className='form-row'> 

                       {"You are about to ALLOW applicants to access the application form for the Leadership Transformation Programme. Are you sure you want to proceed?"}                     
                       <br />  <br />                     
                    </div>
                     <Btn type="Submit" attrBtn={{ color: 'primary', className: 'me-2' }}>{"Start Application Period"}</Btn>
                     <Btn attrBtn={{ color: 'secondary', onClick: applicationPeriodToggle }}>{"Back"}</Btn>
                   </Form>
                 </ModalBody>
               </Modal>
               </span>
                 ):(
                  <span> 
                    <Modal className='modal-bookmark' isOpen={applicationPeriodModal} toggle={applicationPeriodToggle} size='lg'>
                 <ModalHeader toggle={applicationPeriodToggle}>{"End Application Period"}</ModalHeader>
                 <ModalBody>
                   <Form className='form-bookmark needs-validation' onSubmit={(e) => {handleSubmit5(onSubmit5)(e)}}>
                     <div className='form-row'> 

                       {"You are about to PREVENT applicants from accessing the application form for the Leadership Transformation Programme. Are you sure you want to proceed?"}                     
                        <br />  <br />                    
                    </div>
                     <Btn type="Submit" attrBtn={{ color: 'primary', className: 'me-2' }}>{"End Application Period"}</Btn>
                     <Btn attrBtn={{ color: 'secondary', onClick: applicationPeriodToggle }}>{"Back"}</Btn>
                   </Form>
                 </ModalBody>
               </Modal>
               </span>
                 )}
                  
                  </div>
                </Col>

                <Col md="6">
                  <div className="text-end"> 
                    
                
                 <Modal className='modal-bookmark' isOpen={isSearchApplication? searchApplicationModal:withdrawApplicationModal} toggle={isSearchApplication? searchApplicationToggle:withdrawApplicationToggle} size='lg'>

                 {isSearchApplication?(
                       <ModalHeader toggle={searchApplicationToggle}>{"Search for Application"}</ModalHeader>
                     ):( <ModalHeader toggle={withdrawApplicationToggle}>{"Withdraw Application"}</ModalHeader>)}
                
                 
                 {withdrawalSearchResultsIn? (

                   <ModalBody>
                   
                     
                     {budgetNguidelines.omang_to_withdraw_exists!=undefined&&budgetNguidelines.omang_to_withdraw_exists?(
                      <span>
                      <Form className='form-bookmark needs-validation' onSubmit={(e) => {handleSubmit6(onSubmit6)(e)}}>
                      <div className='form-row'>

                       <H5>{"Applicant Details"}</H5>
                       <FormGroup className='col-md-12'>
                         <Label><H6>{"Name : "}</H6></Label>{budgetNguidelines.withdrawal_applicant_details.firstname}<br />
                         <Label><H6>{"Surname : "}</H6></Label>{budgetNguidelines.withdrawal_applicant_details.surname}<br />
                         <Label><H6>{"Omang : "}</H6></Label>{budgetNguidelines.withdrawal_applicant_details.applicant_employee_id}<br />
                         <Label><H6>{"Application Date : "}</H6></Label> {budgetNguidelines.withdrawal_applicant_details.date_added}<br />                        
                       </FormGroup>                      
                       <input className='form-control' defaultValue={budgetNguidelines.omang_to_withdraw} name='omang_to_withdraw' type='hidden' {...register6('omang_to_withdraw', { required: true })} />
                       <input className='form-control' defaultValue={budgetNguidelines.withdrawal_applicant_details.item_id} name='application_id' type='hidden' {...register6('application_id', { required: true })} />
                                             
                    </div>
                       
                  {isSearchApplication?(
                    <span><Link to={`${process.env.PUBLIC_URL}/dpsm/scheme/review-application/ltp/`+budgetNguidelines.withdrawal_applicant_details.item_id}>                          
                     <Btn attrBtn={{  color: 'primary', className: 'btn', type: 'button' }}> Review/Edit Application </Btn> {" "}               
                    </Link>
                      <Btn attrBtn={{ color: 'secondary', onClick: searchApplicationToggle }}>{"Back"}</Btn></span>
                     ):(<span><Btn type="Submit"  value="withdraw_application" name="withdraw_application" attrBtn={{ color: 'success', className: 'me-2' }}>{"Widthraw Application"}</Btn>
                     {" "}<Btn attrBtn={{ color: 'secondary', onClick: withdrawApplicationToggle }}>{"Back"}</Btn></span>)}
                                         
                   </Form>
                    </span>):  (
                      
                      <span>
                        <Form className='form-bookmark needs-validation' onSubmit={(e) => {handleSubmit6(onSubmit6b)(e)}}>
                         <H6 style={{color:"red"}}><span style={{color:"red"}} >{"No application has been made by the Omang number you entered. Please check the Omang again."}</span></H6>
                       <div className='form-row'>
                       
                       <FormGroup className='col-md-12'>
                         <Label><H6>{"Omang Number: "}</H6></Label>
                         <Row>
                           <Col sm='8'>
                             <input className='form-control' defaultValue={budgetNguidelines.omang_to_withdraw} name='omang_to_withdraw' type='text' {...register6('omang_to_withdraw', { required: true })} />
                             <span style={{ color: 'red' }}>{errors6.omang_to_withdraw && 'Omang of the applicant is required'}</span>
                           </Col>                  
                         </Row>
                       </FormGroup> 
                     
                                            
                        </div>
                        <Btn type="Submit" value="search_application" name="search_application" attrBtn={{ color: 'primary', className: 'me-2' }}>{"Search Application"}</Btn>
                  {isSearchApplication?(
                      <Btn attrBtn={{ color: 'secondary', onClick: searchApplicationToggle }}>{"Back"}</Btn>
                     ):(<Btn attrBtn={{ color: 'secondary', onClick: withdrawApplicationToggle }}>{"Back"}</Btn>)}
                   </Form>
                      </span>

                       )
                     }
                     
                 </ModalBody>
                 ):(
                  <ModalBody>
                   <Form className='form-bookmark needs-validation' onSubmit={(e) => {handleSubmit6(onSubmit6b)(e)}}>
                     <div className='form-row'>
                       
                       <FormGroup className='col-md-12'>
                         <Label><H6>{"Omang Number: "}</H6></Label>
                         <Row>
                           <Col sm='8'>
                             <input className='form-control' defaultValue={budgetNguidelines.omang_to_withdraw} name='omang_to_withdraw' type='text' {...register6('omang_to_withdraw', { required: true })} />
                             <span style={{ color: 'red' }}>{errors6.omang_to_withdraw && 'Omang of the applicant is required'}</span>
                           </Col>                  
                         </Row>
                       </FormGroup> 
                     
                                            
                    </div>
                     <Btn type="Submit" value="search_application" name="search_application" attrBtn={{ color: 'primary', className: 'me-2' }}>{"Search Application"}</Btn>
                     {isSearchApplication?(
                      <Btn attrBtn={{ color: 'secondary', onClick: searchApplicationToggle }}>{"Back"}</Btn>
                     ):(<Btn attrBtn={{ color: 'secondary', onClick: withdrawApplicationToggle }}>{"Back"}</Btn>)}
                   </Form>
                 </ModalBody>)}

               </Modal>
                                    
                  </div>
                </Col>


                
                </Row>
              
              
              ) : null
                }
				
            </Container>
        </Fragment>
    );
};
export default ProductListContain;